import { UserDTO } from '@/types/other';
import { setLanguageCookie } from '@/utilites/languageCookie';
import { parseUserPhoneNumber } from '@/utilites/user/user.utils';

export default async function getUserData_v2(): Promise<UserDTO | null> {
  try {
    const response = await fetch('/api/get-user');
    if (response.status === 401) {
      return null;
    }
    const user: UserDTO = await response.json();
    if (user && 'id' in user) {
      setLanguageCookie(user.local);
      return parseUserPhoneNumber(user);
    }
    return null;
  } catch (e: unknown) {
    console.error(e);
    return null;
  }
}
